
import { Options, Vue } from 'vue-class-component';
import CountryPicker from "@/components/CountryPicker.vue"
import NumberPicker from "@/components/NumberPicker.vue"
import DatePicker from "@vuepic/vue-datepicker"
import {Prop} from "vue-property-decorator";


@Options({
  components: {
    CountryPicker,
    DatePicker,
    NumberPicker,
  },
})
export default class extends Vue {
  opened = false;
  height = 0;

  openPanel(){
    this.opened = !this.opened;
    if(this.opened) {
      const block = this.$refs.content as HTMLElement
      this.height = block.getBoundingClientRect().height;
    } else {
      this.height = 0;
    }
  }

}
